<div class="PageContent">

    <div class="overlayTransparent animated fadeIn" *ngIf="this.SearchedProducts?.length > 0" (click)="CloseOverlay();"></div>

    <!-- Delete Product Confirmation -->
    <div class="ModernPopupOverlay" *ngIf="ShowDeleteProductQuestion" (click)="ShowDeleteProductQuestion = false;">
      <div class="ModernPopup small" (click)="$event.stopPropagation()">
        <div class="ModernPopupHeader">
          <div class="ModernPopupTitle"><i class="material-icons">warning</i><span>{{ 'Configuration.DeleteQuestion' | translate }}</span></div>
          <button class="ModernPopupClose" (click)="ShowDeleteProductQuestion = false;"><i class="material-icons">close</i></button>
        </div>
        <div class="ModernPopupBody">
          <p class="ModernPopupDescription">{{ 'Configuration.DeleteQuestionDescription' | translate }}</p>
        </div>
        <div class="ModernPopupFooter">
          <button class="ModernButton outline" [disabled]="this.parent.loading" (click)="ShowDeleteProductQuestion = false;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
          <button class="ModernButton danger" [disabled]="this.parent.loading" (click)="ShowDeleteProductQuestion = false;DeleteIndustryProduct();">{{ 'Configuration.DeleteYesButton' | translate }}</button>
        </div>
      </div>
    </div>

    <!-- Reset Search Results Confirmation -->
    <div class="ModernPopupOverlay" *ngIf="ShowResetIndustryProductsSearchResultsQuestion" (click)="ShowResetIndustryProductsSearchResultsQuestion = false;">
      <div class="ModernPopup small" (click)="$event.stopPropagation()">
        <div class="ModernPopupHeader">
          <div class="ModernPopupTitle"><i class="material-icons">factory</i><span>{{ 'ResetIndustryProductsSearchResults' | translate }}</span></div>
          <button class="ModernPopupClose" (click)="ShowResetIndustryProductsSearchResultsQuestion = false;"><i class="material-icons">close</i></button>
        </div>
        <div class="ModernPopupBody">
          <p class="ModernPopupDescription">{{ 'ResetIndustryProductsSearchResultsDescription' | translate }}</p>
        </div>
        <div class="ModernPopupFooter">
          <button class="ModernButton outline" [disabled]="this.parent.loading" (click)="ShowResetIndustryProductsSearchResultsQuestion = false;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
          <button class="ModernButton" style="background: #1565c0; color: #fff; border: none;" [disabled]="this.parent.loading" (click)="ResetIndustryProductsSearchResults();"><i class="material-icons" style="color: #fff;">factory</i><i class="material-icons" style="color: #fff; margin-left: -4px;">refresh</i> {{ 'ResetSearchResults' | translate }}</button>
        </div>
      </div>
    </div>

    <!-- Reset All Cart Items Search Results Confirmation -->
    <div class="ModernPopupOverlay" *ngIf="ShowResetAllCartItemsSearchResultsQuestion" (click)="ShowResetAllCartItemsSearchResultsQuestion = false;">
      <div class="ModernPopup small" (click)="$event.stopPropagation()">
        <div class="ModernPopupHeader">
          <div class="ModernPopupTitle"><i class="material-icons">shopping_cart</i><span>{{ 'ResetAllCartItemsSearchResults' | translate }}</span></div>
          <button class="ModernPopupClose" (click)="ShowResetAllCartItemsSearchResultsQuestion = false;"><i class="material-icons">close</i></button>
        </div>
        <div class="ModernPopupBody">
          <p class="ModernPopupDescription">{{ 'ResetAllCartItemsSearchResultsDescription' | translate }}</p>
        </div>
        <div class="ModernPopupFooter">
          <button class="ModernButton outline" [disabled]="this.parent.loading" (click)="ShowResetAllCartItemsSearchResultsQuestion = false;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
          <button class="ModernButton" style="background: #2e7d32; color: #fff; border: none;" [disabled]="this.parent.loading" (click)="ResetAllCartItemsSearchResults();"><i class="material-icons" style="color: #fff;">shopping_cart</i><i class="material-icons" style="color: #fff; margin-left: -4px;">sync</i> {{ 'ResetCartItemsSearchResults' | translate }}</button>
        </div>
      </div>
    </div>

    <!-- Duplicate Error Add -->
    <div class="ModernPopupOverlay" *ngIf="DupplicateError && DupplicateErrorAdd" (click)="DupplicateError = false;DupplicateErrorAdd = false;">
      <div class="ModernPopup small" (click)="$event.stopPropagation()">
        <div class="ModernPopupHeader">
          <div class="ModernPopupTitle"><i class="material-icons">error_outline</i><span>{{ 'ProductDupplicateErrorTitle' | translate }}</span></div>
          <button class="ModernPopupClose" (click)="DupplicateError = false;"><i class="material-icons">close</i></button>
        </div>
        <div class="ModernPopupBody">
          <p class="ModernPopupDescription">{{this.DupplicateErrorMessage}}</p>
        </div>
        <div class="ModernPopupFooter">
          <button class="ModernButton outline" [disabled]="this.parent.loading" (click)="DupplicateError = false;DupplicateErrorAdd = false;">{{ 'No' | translate }}</button>
          <button class="ModernButton danger" [disabled]="this.parent.loading" (click)="DupplicateError = false;DupplicateErrorAdd = false;AddIndustryProudct(true);">{{ 'Yes' | translate }}</button>
        </div>
      </div>
    </div>

    <!-- Duplicate Error Update -->
    <div class="ModernPopupOverlay" *ngIf="DupplicateError && DupplicateErrorUpdate" (click)="DupplicateError = false;DupplicateErrorUpdate = false;">
      <div class="ModernPopup small" (click)="$event.stopPropagation()">
        <div class="ModernPopupHeader">
          <div class="ModernPopupTitle"><i class="material-icons">error_outline</i><span>{{ 'ProductDupplicateErrorTitle' | translate }}</span></div>
          <button class="ModernPopupClose" (click)="DupplicateError = false;"><i class="material-icons">close</i></button>
        </div>
        <div class="ModernPopupBody">
          <p class="ModernPopupDescription">{{this.DupplicateErrorMessage}}</p>
        </div>
        <div class="ModernPopupFooter">
          <button class="ModernButton outline" [disabled]="this.parent.loading" (click)="DupplicateError = false;DupplicateErrorUpdate = false;">{{ 'No' | translate }}</button>
          <button class="ModernButton danger" [disabled]="this.parent.loading" (click)="DupplicateError = false;DupplicateErrorUpdate = false;UpdateIndustryProduct(true);">{{ 'Yes' | translate }}</button>
        </div>
      </div>
    </div>

    <!-- Add/Edit Product Popup -->
    <div class="ModernPopupOverlay" *ngIf="ShowAddNewProductForm == true;" (click)="ShowAddNewProductForm = false;">
      <div class="ModernPopup large" (click)="$event.stopPropagation()">
        <div class="ModernPopupHeader">
          <div class="ModernPopupTitle">
            <i class="material-icons">{{this.NewProduct.ID == 0 ? 'add_circle' : 'edit'}}</i>
            <span *ngIf="this.NewProduct.ID == 0;">{{'AddNewProduct' | translate}}</span>
            <span *ngIf="this.NewProduct.ID > 0;">{{'ModifyProduct' | translate}}: {{this.NewProduct.Brand?.Name}} {{this.NewProduct.Name}}</span>
          </div>
          <button class="ModernPopupClose" (click)="ShowAddNewProductForm = false;"><i class="material-icons">close</i></button>
        </div>
        <div class="ModernPopupBody">
          <div style="display: flex; gap: 20px;">
            <!-- Left Column: General Information -->
            <div style="flex: 2;">
              <label class="ModernFormLabel" style="margin-bottom: 10px; display: block;">
                <i class="material-icons" style="font-size: 14px; vertical-align: middle; margin-right: 4px;">radio_button_checked</i>
                {{'GeneralInformation' | translate}}
              </label>
              <div class="ModernFormGroup">
                <label class="ModernFormLabel">{{'Name' | translate}} *</label>
                <input type="text" class="ModernFormInput" autocomplete="off" [(ngModel)]="this.NewProduct.Name" placeholder="{{'Name' | translate}}">
              </div>
              <div class="ModernFormGroup">
                <label class="ModernFormLabel">{{'PartNumber' | translate}}</label>
                <input type="text" class="ModernFormInput" autocomplete="off" [(ngModel)]="this.NewProduct.PartNumber" placeholder="{{'PartNumber' | translate}}">
              </div>
              <div class="ModernFormGroup">
                <label class="ModernFormLabel">{{'SelectBrand' | translate}} *</label>
                <div style="position: relative;">
                  <input type="text" class="ModernFormInput" style="padding-right: 34px;"
                         placeholder="{{'SelectBrand' | translate}}" autocomplete="off"
                         [(ngModel)]="this.NewProduct.Brand.Name"
                         (ngModelChange)="this.brandSearchTermUpdate.next($event)"
                         (click)="InitializeBrands();" (focus)="showPopupBrandResults = true;">
                  <i class="material-icons" *ngIf="this.NewProduct.Brand?.Name?.length > 0;" (click)="ClearSearchBrand(); showPopupBrandResults = false;"
                     style="position: absolute; right: 10px; top: 8px; font-size: 16px; color: #ff3b30; cursor: pointer;">close</i>
                  <i class="material-icons" *ngIf="!(this.NewProduct.Brand?.Name?.length > 0)"
                     style="position: absolute; right: 10px; top: 8px; font-size: 16px; color: #8e8e93;">search</i>
                  <div *ngIf="showPopupBrandResults" (click)="showPopupBrandResults = false;" style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; z-index: 200; background: transparent;"></div>
                  <div class="page-search-results" *ngIf="showPopupBrandResults && Brands?.length > 0" style="top: 38px; z-index: 201;">
                    <div class="page-search-result" *ngFor="let brand of Brands" (click)="this.NewProduct.Brand = brand; showPopupBrandResults = false;">
                      <span class="page-search-result-name">{{brand.Name}}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="ModernFormGroup" *ngIf="this.NewProduct.ID == 0;">
                <label class="ModernFormLabel">{{'Creator' | translate}}</label>
                <input type="text" class="ModernFormInput" disabled autocomplete="off" [(ngModel)]="this.NewProduct.Creator.UIName">
              </div>
              <div class="ModernFormGroup">
                <label class="ModernFormLabel">{{'UpdateingUser' | translate}}</label>
                <input type="text" class="ModernFormInput" disabled autocomplete="off" [(ngModel)]="this.NewProduct.Updater.UIName">
              </div>
              <div class="ModernFormGroup">
                <label class="ModernFormLabel">{{'ProductManufacturingStatus' | translate}}</label>
                <select class="ModernFormInput" [(ngModel)]="this.NewProduct.ManufacturingStatus" [compareWith]="this.parent.compareFn">
                  <option *ngFor="let s of this.ProductManufacturingStatuses" [ngValue]="s">{{s.Name}}</option>
                </select>
              </div>
              <div class="ModernFormGroup">
                <label class="ModernFormLabel">{{'ProductVersionStatus' | translate}}</label>
                <select class="ModernFormInput" [(ngModel)]="this.NewProduct.VersionStatus" [compareWith]="this.parent.compareFn">
                  <option *ngFor="let s of this.ProductVersionStatuses" [ngValue]="s">{{s.Name}}</option>
                </select>
              </div>
            </div>
            <!-- Right Column: Details -->
            <div style="flex: 1;">
              <label class="ModernFormLabel" style="margin-bottom: 10px; display: block;">
                <i class="material-icons" style="font-size: 14px; vertical-align: middle; margin-right: 4px;">format_list_bulleted</i>
                {{'Details' | translate}}
              </label>
              <div class="ModernFormGroup">
                <label class="ModernFormLabel">{{'Weight' | translate}}</label>
                <input type="text" class="ModernFormInput" (keypress)="parent.OnlyNumbers($event)" autocomplete="off" [(ngModel)]="this.NewProduct.Stats.Weight" placeholder="{{'Weight' | translate}}">
              </div>
              <div class="ModernFormGroup">
                <label class="ModernFormLabel">{{'WeightMeasurementType' | translate}}</label>
                <select class="ModernFormInput" [(ngModel)]="this.NewProduct.Stats.WeightMeasurementType" [compareWith]="this.parent.compareFn">
                  <option *ngFor="let w of this.WeightMeasurementTypes" [ngValue]="w">{{w.Name}}</option>
                </select>
              </div>
              <div class="ModernFormGroup">
                <label class="ModernFormLabel">{{'HSCode' | translate}}</label>
                <input type="text" class="ModernFormInput" autocomplete="off" [(ngModel)]="this.NewProduct.Stats.HSCode" placeholder="{{'HSCode' | translate}}">
              </div>
              <div class="ModernFormGroup">
                <label class="ModernFormLabel">{{'EAN' | translate}}</label>
                <input type="text" class="ModernFormInput" autocomplete="off" [(ngModel)]="this.NewProduct.Stats.EAN" placeholder="{{'EAN' | translate}}">
              </div>
              <div class="ModernFormGroup">
                <label class="ModernFormLabel">{{'COO' | translate}}</label>
                <select class="ModernFormInput" [(ngModel)]="this.NewProduct.Stats.COO" [compareWith]="this.parent.compareFn">
                  <option *ngFor="let c of this.Countries" [ngValue]="c">{{c.Name}}</option>
                </select>
              </div>
              <div style="display: flex; gap: 8px;">
                <div class="ModernFormGroup" style="flex: 1;">
                  <label class="ModernFormLabel">{{'StandardListPrice' | translate}}</label>
                  <input type="text" class="ModernFormInput" autocomplete="off" [(ngModel)]="this.NewProduct.Stats.StandardListPrice.UIUnitPrice" placeholder="{{'StandardListPrice' | translate}}">
                </div>
                <div class="ModernFormGroup" style="flex: 1;">
                  <label class="ModernFormLabel">{{'Currency' | translate}}</label>
                  <select class="ModernFormInput" [(ngModel)]="this.NewProduct.Stats.StandardListPrice.Currency" [compareWith]="this.parent.compareFn">
                    <option *ngFor="let c of this.Currencies" [ngValue]="c">{{c.Name}}</option>
                  </select>
                </div>
              </div>
              <div class="auto-save-toggle-container" style="margin-top: 6px;">
                <label class="auto-save-toggle">
                  <input type="checkbox" [(ngModel)]="this.NewProduct.Activated">
                  <span class="toggle-slider"></span>
                </label>
                <span class="auto-save-label">{{'ActiveProduct' | translate}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="ModernPopupFooter">
          <button class="ModernButton primary" *ngIf="this.NewProduct.ID == 0;" (click)="AddIndustryProudct();">
            <i class="material-icons">add</i> {{'AddNewProduct' | translate}}
          </button>
          <button class="ModernButton primary" *ngIf="this.NewProduct.ID > 0;" (click)="UpdateIndustryProduct();">
            <i class="material-icons">edit</i> {{'ModifyProduct' | translate}}
          </button>
        </div>
      </div>
    </div>

    <!-- Page Title Bar -->
    <div class="page-title-bar">
      <div class="page-title-left">
        <i class="material-icons" style="font-size: 18px; color: #007aff;">sd_storage</i>
        <span class="page-title-text">{{'Products' | translate}}</span>
      </div>
      <div class="page-title-controls">
        <div class="page-brand-filter" style="position: relative; z-index: 202;">
          <input type="text" class="ModernFormInput" style="padding-right: 30px; position: relative; z-index: 203;" placeholder="{{'SelectBrand' | translate}}" autocomplete="off"
                 [(ngModel)]="this.FilterBrandName"
                 (ngModelChange)="this.brandSearchTermUpdate.next($event)"
                 (click)="InitializeBrands(); showTitleBrandResults = true;" (focus)="showTitleBrandResults = true;">
          <i class="material-icons" *ngIf="this.FilterBrandName?.length > 0" (click)="ClearSearchBrand(); showTitleBrandResults = false; GetIndustryProductsFiltered();"
             style="position: absolute; right: 8px; top: 8px; font-size: 16px; color: #ff3b30; cursor: pointer; z-index: 203;">close</i>
          <i class="material-icons" *ngIf="!(this.FilterBrandName?.length > 0)"
             style="position: absolute; right: 8px; top: 8px; font-size: 16px; color: #8e8e93; pointer-events: none; z-index: 203;">arrow_drop_down</i>
          <div *ngIf="showTitleBrandResults" (click)="showTitleBrandResults = false;" style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; z-index: 200; background: transparent;"></div>
          <div class="page-search-results" *ngIf="showTitleBrandResults && Brands?.length > 0" style="top: 38px; z-index: 204; width: 240px;">
            <div class="page-search-result" *ngFor="let brand of Brands" (click)="this.Filter.Brand = brand; this.FilterBrandName = brand.Name; showTitleBrandResults = false; AddActiveFilter(brand.Name, 'Brand');">
              <span class="page-search-result-name">{{brand.Name}}</span>
            </div>
          </div>
        </div>
        <div class="page-search-bar">
          <mat-spinner *ngIf="loadingProducts" style="position: absolute; left: 10px; top: 7px;" [diameter]="20"></mat-spinner>
          <i class="material-icons" *ngIf="loadingProducts != true;" style="position: absolute; left: 10px; top: 7px; font-size: 20px; color: #007aff;">search</i>
          <input type="text" class="ModernFormInput" style="padding-left: 36px; width: 100%;" placeholder="{{'SearchProducts' | translate}}" autocomplete="off"
                 (click)="InitializeSearchProduct();" [(ngModel)]="this.Filter.SearchTerm" (ngModelChange)="this.searchTermUpdate.next($event)">
          <i class="material-icons" *ngIf="this.SearchedProducts?.length > 0;" style="position: absolute; right: 10px; top: 7px; font-size: 20px; color: #ff3b30; cursor: pointer;"
             (click)="this.SearchTerm = ''; this.SearchedProducts.length = 0; this.Filter.SearchTerm = '';">close</i>
          <div class="page-search-results" *ngIf="this.SearchedProducts?.length > 0">
            <div class="page-search-result" *ngFor="let p of this.SearchedProducts" (click)="GetIndustryProductByID(p.ProductID, true);">
              <span class="page-search-result-name">{{p.FKBrandName}} {{p.ProductName}}</span>
              <span class="page-search-result-pn">{{p.ProductPartNumber}}</span>
            </div>
          </div>
        </div>
        <button class="ModernButton primary" (click)="InitializeNewIndustryProduct();">
          <i class="material-icons">add</i> {{'AddNewProduct' | translate}}
        </button>
      </div>
    </div>

    <!-- Command Bar -->
    <div class="page-command-bar">
      <button class="ModernButton outline" style="background: #1565c0; color: #fff; border: none;" (click)="ShowResetIndustryProductsSearchResultsQuestion = true;">
        <i class="material-icons" style="color: #fff;">factory</i>
        <i class="material-icons" style="color: #fff; margin-left: -4px;">refresh</i> {{'ResetSearchResults' | translate}}
      </button>
      <button class="ModernButton outline" style="background: #2e7d32; color: #fff; border: none;" (click)="ShowResetAllCartItemsSearchResultsQuestion = true;">
        <i class="material-icons" style="color: #fff;">shopping_cart</i>
        <i class="material-icons" style="color: #fff; margin-left: -4px;">sync</i> {{'ResetCartItemsSearchResults' | translate}}
      </button>
      <button class="ModernButton outline" style="background: #1c1c1e; color: #fff; border: none;" (click)="ShowHideHSCodesMenu();">
        <i class="material-icons" style="color: #fff;">security</i> {{'HSCodesMenu' | translate}}
      </button>
    </div>

    <!-- Products Table -->
    <div class="page-table-container">
      <div class="modern-table-container">
        <table class="modern-table" style="table-layout: fixed;">
          <thead>
            <tr>
              <th style="width: 5%; text-align: center;">#</th>
              <th style="width: 25%;">{{'Product' | translate}}</th>
              <th style="width: 20%;">{{'Properties' | translate}}</th>
              <th style="width: 10%;">{{'Brand' | translate}}</th>
              <th style="width: 10%;">{{'EventRegister' | translate}}</th>
              <th style="width: 10%;">{{'UpdateingUser' | translate}}</th>
              <th style="width: 10%; text-align: center;">{{'ActiveProduct' | translate}}</th>
              <th style="width: 10%; text-align: center;">{{'Actions' | translate}}</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let p of this.Products; let i=index;">
              <tr>
                <td class="text-center">{{i + 1}}</td>
                <td>
                  <div class="product-info">
                    <div class="product-name">{{p.Name}}</div>
                    <div class="product-details">
                      <span class="detail-item"><span class="detail-label">{{'Manufacturer' | translate}}:</span> {{p.Brand?.Name}}</span>
                      <span *ngIf="p.PartNumber != null" class="detail-item"><span class="detail-label">{{'PartNumber' | translate}}:</span> {{p.PartNumber}}</span>
                    </div>
                    <button *ngIf="p.ListPriceOffers?.length > 0" class="ModernButton outline" style="height: 22px; font-size: 9px; margin-top: 4px;" (click)="p.ShowOffers = !p.ShowOffers;">
                      <i class="material-icons" style="font-size: 12px;">{{p.ShowOffers ? 'expand_less' : 'expand_more'}}</i> {{'Offers' | translate}}
                    </button>
                  </div>
                </td>
                <td>
                  <div class="product-details" style="padding-top: 4px;">
                    <span *ngIf="p.Stats?.HSCode != null" class="detail-item"><span class="detail-label">{{'HSCode' | translate}}:</span> <span class="hscode-valid">{{getHSCodeParts(p.Stats?.HSCode).valid}}</span><span class="hscode-excess" *ngIf="getHSCodeParts(p.Stats?.HSCode).hasExcess">{{getHSCodeParts(p.Stats?.HSCode).excess}}</span></span>
                    <span *ngIf="p.Stats?.COO != null" class="detail-item"><span class="detail-label">{{'COO' | translate}}:</span> {{p.Stats?.COO?.Name}}</span>
                    <span *ngIf="p.Stats?.EAN != null" class="detail-item"><span class="detail-label">{{'EAN' | translate}}:</span> {{p.Stats?.EAN}}</span>
                    <span *ngIf="p.Stats?.Weight != null" class="detail-item"><span class="detail-label">{{'Weight' | translate}}:</span> {{p.Stats?.Weight}} {{p.Stats?.WeightMeasurementType?.Name}}</span>
                    <span class="detail-item"><span class="detail-label">{{'ProductManufacturingStatus' | translate}}:</span> {{p.ManufacturingStatus?.Name}}</span>
                    <span class="detail-item"><span class="detail-label">{{'ProductVersionStatus' | translate}}:</span> {{p.VersionStatus?.Name}}</span>
                  </div>
                </td>
                <td><strong style="font-size: 11px;">{{p.Brand?.Name}}</strong></td>
                <td style="font-size: 10px; color: #8e8e93;">{{p.EventRegisterUI}}</td>
                <td style="font-size: 10px; color: #8e8e93;">{{p.Updater?.UIName}}</td>
                <td class="text-center">
                  <span *ngIf="p.Activated" style="color: #34c759; font-weight: 600; font-size: 10px;">{{'Activ' | translate}}</span>
                </td>
                <td class="text-center">
                  <i class="material-icons" style="font-size: 20px; color: #8e8e93; cursor: pointer; border: 1px solid rgba(0,0,0,0.08); border-radius: 6px; padding: 2px;" [matMenuTriggerFor]="menu">more_horiz</i>
                  <mat-menu #menu="matMenu">
                    <button mat-menu-item (click)="InitializeNewIndustryProduct(p);">
                      <i class="material-icons" style="font-size: 18px; margin-right: 8px;">edit</i>
                      <span>{{ 'Receptions.Table.ButtonMenu.modify' | translate }}</span>
                    </button>
                    <button mat-menu-item (click)="InitializeNewIndustryProduct(p, true);">
                      <i class="material-icons" style="font-size: 18px; margin-right: 8px;">content_copy</i>
                      <span>{{ 'CopyProduct' | translate }}</span>
                    </button>
                    <button mat-menu-item (click)="this.NewProduct = p; this.ShowDeleteProductQuestion = true;">
                      <i class="material-icons" style="font-size: 18px; margin-right: 8px; color: #ff3b30;">close</i>
                      <span style="color: #ff3b30;">{{ 'Delete' | translate }}</span>
                    </button>
                  </mat-menu>
                </td>
              </tr>
              <!-- Offers Sub-Table -->
              <tr *ngIf="p.ShowOffers == true;" style="background: rgba(242,242,247,0.6);">
                <td colspan="8" style="padding: 8px 14px;">
                  <table class="modern-table" style="table-layout: fixed; margin: 0;">
                    <thead>
                      <tr>
                        <th style="width: 5%; text-align: center;">#</th>
                        <th style="width: 25%;">{{'PriceInformation' | translate}}</th>
                        <th style="width: 20%;">{{'Supplier' | translate}}</th>
                        <th style="width: 12%;">{{'Currency' | translate}}</th>
                        <th style="width: 13%;">{{'LeadTime' | translate}}</th>
                        <th style="width: 12%; text-align: center;">{{'IsStockOffer' | translate}}</th>
                        <th style="width: 13%; text-align: right;">{{'StockQuantity' | translate}}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let o of p.ListPriceOffers; let j=index;" [style.background]="o.IsStockOffer ? 'rgba(52,199,89,0.06)' : 'rgba(0,122,255,0.04)'">
                        <td class="text-center">{{j + 1}}</td>
                        <td>
                          <span style="font-weight: 600; font-size: 11px; color: #007aff;">{{'PurchasePrice' | translate}}: </span>
                          <span *ngIf="o.DiscountedPrice > 0;" style="font-weight: 600;">{{o.DiscountedPrice}} {{o.Currency?.Name}}</span>
                          <span *ngIf="!(o.DiscountedPrice > 0);" style="color: #8e8e93;">------</span>
                        </td>
                        <td>{{o.Partner?.Name}}</td>
                        <td>{{o.Currency?.Name}}</td>
                        <td>{{o.LeadTime?.Units}} {{o.LeadTime?.Type?.Name}}</td>
                        <td class="text-center">
                          <span *ngIf="o.IsStockOffer == true;" style="color: #34c759; font-weight: 600;">{{'Yes'| translate}}</span>
                          <span *ngIf="o.IsStockOffer == false;" style="color: #8e8e93;">{{'No'| translate}}</span>
                        </td>
                        <td style="text-align: right;">{{o.StockQuantity}}</td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </div>
  </div>

<!-- HS Codes Menu Popup -->
<div class="ModernPopupOverlay" *ngIf="ShowHSCodesMenu == true;" (click)="ShowHSCodesMenu = false;">
  <div class="ModernPopup xlarge" (click)="$event.stopPropagation()">
    <div class="ModernPopupHeader">
      <div class="ModernPopupTitle">
        <i class="material-icons">security</i>
        <span>{{'HSCodesMenu' | translate}}</span>
      </div>
      <button class="ModernPopupClose" (click)="ShowHideHSCodesMenu();">
        <i class="material-icons">close</i>
      </button>
    </div>

    <!-- Tab Navigation -->
    <div class="hscodes-tabs">
      <button class="hscodes-tab" [class.hscodes-tab--active]="HSCodesPopupTab === 'hscodes'" (click)="HSCodesPopupTab = 'hscodes';">
        {{'HSCodesMenu' | translate}}
      </button>
      <button class="hscodes-tab" [class.hscodes-tab--active]="HSCodesPopupTab === 'missing_descriptions'" (click)="HSCodesPopupTab = 'missing_descriptions'; GetHSCodesWithoutDescriptions();">
        {{'HSCodesMissingDescriptions' | translate}}
      </button>
    </div>

    <!-- Tab: HSCodes -->
    <div class="ModernPopupBody" *ngIf="HSCodesPopupTab === 'hscodes'">
      <!-- Search Section -->
      <div class="ModernFormGroup">
        <label class="ModernFormLabel">{{'SearchHSCodes' | translate}}</label>
        <div style="position: relative;">
          <input type="text" class="ModernFormInput" style="padding-left: 36px;"
                 placeholder="{{'SearchHSCodes' | translate}}"
                 [(ngModel)]="this.HSCodesFilter.Code"
                 (ngModelChange)="this.HSCodesSearchText.next($event)">
          <i class="material-icons" style="position: absolute; left: 10px; top: 8px; font-size: 18px; color: #8e8e93;">search</i>
          <mat-spinner *ngIf="loadingHSCodes" style="position: absolute; right: 10px; top: 7px;" [diameter]="20"></mat-spinner>
        </div>
      </div>
      <div *ngIf="this.ShowGetHSCodeViesData == true;" style="display: flex; align-items: center; gap: 12px; margin-bottom: 14px; padding: 8px 12px; background: rgba(255,149,0,0.08); border-left: 3px solid #ff9500; border-radius: 6px;">
        <span style="font-size: 11px; color: #8e8e93; font-weight: 500;">{{'NoResultsFound' | translate}}</span>
        <button class="ModernButton primary" (click)="this.InitializeNewHSCode(this.HSCodesFilter.Code);">
          <i class="material-icons">add</i> {{'AddNew' | translate}}
        </button>
      </div>

      <!-- HS Codes Table -->
      <div *ngIf="this.HSCodes?.length > 0">
        <table class="modern-table" style="table-layout: fixed;">
          <thead>
            <tr>
              <th style="width: 4%; text-align: center;">#</th>
              <th style="width: 20%;">{{'HSCode' | translate}}</th>
              <th style="width: 13%;">{{'ImportTax' | translate}}</th>
              <th style="width: 13%;">{{'ExportTax' | translate}}</th>
              <th style="width: 17%;">{{'COO' | translate}}</th>
              <th style="width: 17%;">{{'ImportingCountry' | translate}}</th>
              <th style="width: 16%; text-align: center;">{{'Actions' | translate}}</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let hs of this.HSCodes; let hsIdx = index;">
              <tr [style.background]="hs.Active === false ? 'rgba(255,59,48,0.06)' : 'transparent'">
                <td class="text-center" style="font-size: 10px; color: #8e8e93; font-weight: 600;">{{hsIdx + 1}}</td>
                <td>
                  <input type="text" class="ModernFormInput" autocomplete="off" [(ngModel)]="hs.Code" placeholder="{{'HSCode' | translate}}"
                         (blur)="ValidateAndSanitizeHSCode(hs)" [style.borderColor]="hs.HSCodeValid === false ? '#ff3b30' : ''">
                  <div class="hscode-preview" *ngIf="getHSCodeParts(hs.Code).hasExcess">
                    <span class="hscode-valid">{{getHSCodeParts(hs.Code).valid}}</span><span class="hscode-excess">{{getHSCodeParts(hs.Code).excess}}</span>
                  </div>
                </td>
                <td>
                  <input type="text" class="ModernFormInput" autocomplete="off" [(ngModel)]="hs.ImportTax" placeholder="{{'ImportTax' | translate}}">
                </td>
                <td>
                  <input type="text" class="ModernFormInput" autocomplete="off" [(ngModel)]="hs.ExportTax" placeholder="{{'ExportTax' | translate}}">
                </td>
                <td style="position: relative;">
                  <div style="position: relative; z-index: 202;">
                    <input type="text" class="ModernFormInput" autocomplete="off" style="padding-right: 28px; position: relative; z-index: 203;"
                           placeholder="{{'COO' | translate}}"
                           [(ngModel)]="hs.COOSearchTerm"
                           (ngModelChange)="onCountrySearchChange($event)"
                           (click)="openCountryDropdown('coo_' + hsIdx, hs.COOSearchTerm)" (focus)="openCountryDropdown('coo_' + hsIdx, hs.COOSearchTerm)">
                    <i class="material-icons" *ngIf="hs.COOSearchTerm?.length > 0"
                       (click)="clearHSCountry(hs, 'COO')"
                       style="position: absolute; right: 6px; top: 8px; font-size: 14px; color: #ff3b30; cursor: pointer; z-index: 203;">close</i>
                    <i class="material-icons" *ngIf="!(hs.COOSearchTerm?.length > 0)"
                       style="position: absolute; right: 6px; top: 8px; font-size: 14px; color: #8e8e93; pointer-events: none; z-index: 203;">search</i>
                    <div *ngIf="activeCountryDropdown === 'coo_' + hsIdx" (click)="closeCountryDropdown();" style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; z-index: 200; background: transparent;"></div>
                    <div class="page-search-results" *ngIf="activeCountryDropdown === 'coo_' + hsIdx && filteredCountries?.length > 0" style="top: 38px; z-index: 204; max-height: 200px;">
                      <div class="page-search-result" *ngFor="let c of filteredCountries" (click)="selectHSCountry(hs, 'COO', c);">
                        <span class="page-search-result-name">{{c.Name}}</span>
                      </div>
                    </div>
                  </div>
                </td>
                <td style="position: relative;">
                  <div style="position: relative; z-index: 202;">
                    <input type="text" class="ModernFormInput" autocomplete="off" style="padding-right: 28px; position: relative; z-index: 203;"
                           placeholder="{{'ImportingCountry' | translate}}"
                           [(ngModel)]="hs.ImportingCountrySearchTerm"
                           (ngModelChange)="onCountrySearchChange($event)"
                           (click)="openCountryDropdown('importing_' + hsIdx, hs.ImportingCountrySearchTerm)" (focus)="openCountryDropdown('importing_' + hsIdx, hs.ImportingCountrySearchTerm)">
                    <i class="material-icons" *ngIf="hs.ImportingCountrySearchTerm?.length > 0"
                       (click)="clearHSCountry(hs, 'ImportingCountry')"
                       style="position: absolute; right: 6px; top: 8px; font-size: 14px; color: #ff3b30; cursor: pointer; z-index: 203;">close</i>
                    <i class="material-icons" *ngIf="!(hs.ImportingCountrySearchTerm?.length > 0)"
                       style="position: absolute; right: 6px; top: 8px; font-size: 14px; color: #8e8e93; pointer-events: none; z-index: 203;">search</i>
                    <div *ngIf="activeCountryDropdown === 'importing_' + hsIdx" (click)="closeCountryDropdown();" style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; z-index: 200; background: transparent;"></div>
                    <div class="page-search-results" *ngIf="activeCountryDropdown === 'importing_' + hsIdx && filteredCountries?.length > 0" style="top: 38px; z-index: 204; max-height: 200px;">
                      <div class="page-search-result" *ngFor="let c of filteredCountries" (click)="selectHSCountry(hs, 'ImportingCountry', c);">
                        <span class="page-search-result-name">{{c.Name}}</span>
                      </div>
                    </div>
                  </div>
                </td>
                <td style="text-align: center;">
                  <div style="display: flex; align-items: center; justify-content: center; gap: 4px;">
                    <button class="ModernButton primary" style="width: 30px; height: 30px; padding: 0;" (click)="AddUpdateHSCode(hs);" title="{{'Save' | translate}}">
                      <i class="material-icons" style="font-size: 16px;">save</i>
                    </button>
                    <button *ngIf="hs.Active !== false" class="hscode-active-btn hscode-active-on" style="width: 30px; height: 30px; padding: 0;" (click)="ToggleHSCodeActive(hs);" title="{{'Activate' | translate}}">
                      <i class="material-icons" style="font-size: 16px;">check_circle</i>
                    </button>
                    <button *ngIf="hs.Active === false" class="hscode-active-btn hscode-active-off" style="width: 30px; height: 30px; padding: 0;" (click)="ToggleHSCodeActive(hs);" title="{{'Cancel' | translate}}">
                      <i class="material-icons" style="font-size: 16px;">cancel</i>
                    </button>
                    <button class="ModernButton outline" style="width: 30px; height: 30px; padding: 0;" (click)="hs.ShowDescriptions = !hs.ShowDescriptions; InitializeHSCodeDescription(hs); GetHSCodeDescriptions(hs);" title="{{'Descriptions' | translate}}">
                      <i class="material-icons" style="font-size: 16px;">{{hs.ShowDescriptions ? 'expand_less' : 'expand_more'}}</i>
                    </button>
                  </div>
                </td>
              </tr>
              <!-- Descriptions Sub-rows -->
              <tr *ngIf="hs.ShowDescriptions == true;" style="background: rgba(242,242,247,0.6);">
                <td colspan="7" style="padding: 10px 14px;">
                  <!-- Add New Description -->
                  <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 8px; padding: 8px; background: rgba(52,199,89,0.06); border-radius: 8px; border: 1px solid rgba(52,199,89,0.15);">
                    <input type="text" class="ModernFormInput" style="flex: 1;" autocomplete="off" [(ngModel)]="this.HSCodeDescription.Description" placeholder="{{'Description' | translate}}">
                    <select class="ModernFormInput" style="width: 130px;" [(ngModel)]="this.HSCodeDescription.Language" [compareWith]="this.parent.compareFn">
                      <option *ngFor="let l of this.Languages" [ngValue]="l">{{l.Name}}</option>
                    </select>
                    <button class="ModernButton primary" (click)="AddUpdateHSCodeDescription(this.HSCodeDescription);">
                      <i class="material-icons">add</i> {{'Add' | translate}}
                    </button>
                  </div>
                  <!-- Existing Descriptions -->
                  <div *ngFor="let d of hs.Descriptions" style="display: flex; align-items: center; gap: 8px; margin-bottom: 6px; padding: 6px 8px; background: #fff; border-radius: 8px; border: 1px solid rgba(0,0,0,0.06);">
                    <input type="text" class="ModernFormInput" style="flex: 1;" autocomplete="off" [(ngModel)]="d.Description" placeholder="{{'Description' | translate}}">
                    <select class="ModernFormInput" style="width: 130px;" [(ngModel)]="d.Language" [compareWith]="this.parent.compareFn">
                      <option *ngFor="let l of this.Languages" [ngValue]="l">{{l.Name}}</option>
                    </select>
                    <button class="ModernButton primary" style="width: 30px; height: 30px; padding: 0;" (click)="AddUpdateHSCodeDescription(d);" title="{{'Save' | translate}}">
                      <i class="material-icons" style="font-size: 16px;">save</i>
                    </button>
                    <button class="ModernButton danger" style="width: 30px; height: 30px; padding: 0;" (click)="DeleteHSCodeDescription(d);" title="{{'Delete' | translate}}">
                      <i class="material-icons" style="font-size: 16px;">delete_outline</i>
                    </button>
                  </div>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Tab: Missing Descriptions -->
    <div class="ModernPopupBody" *ngIf="HSCodesPopupTab === 'missing_descriptions'">
      <div *ngIf="HSCodesWithoutDescriptionsLoading" style="text-align: center; padding: 40px 0;">
        <mat-spinner [diameter]="30" style="margin: 0 auto;"></mat-spinner>
      </div>
      <div *ngIf="!HSCodesWithoutDescriptionsLoading && (!HSCodesWithoutDescriptions || HSCodesWithoutDescriptions?.length === 0)" style="text-align: center; padding: 40px 0; color: #8e8e93; font-size: 12px;">
        <i class="material-icons" style="font-size: 40px; color: #34c759; display: block; margin-bottom: 8px;">check_circle</i>
        {{'NoResultsFound' | translate}}
      </div>
      <div *ngIf="!HSCodesWithoutDescriptionsLoading && HSCodesWithoutDescriptions?.length > 0" style="display: flex; flex-direction: column; gap: 10px;">
        <div *ngFor="let h of HSCodesWithoutDescriptions; let mdIdx = index;" style="padding: 12px 14px; background: #fff; border: 1px solid rgba(0,0,0,0.06); border-radius: 10px;">
          <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 8px;">
            <span style="font-size: 10px; color: #8e8e93; font-weight: 600; min-width: 20px;">{{mdIdx + 1}}</span>
            <span style="font-weight: 700; font-size: 13px; font-family: 'Consolas', monospace;"><span class="hscode-valid">{{getHSCodeParts(h.Code).valid}}</span><span class="hscode-excess" *ngIf="getHSCodeParts(h.Code).hasExcess">{{getHSCodeParts(h.Code).excess}}</span></span>
            <span *ngIf="h.ImportingCountry?.Name" style="font-size: 10px; color: #8e8e93; background: rgba(0,0,0,0.04); padding: 2px 8px; border-radius: 40px;">{{h.ImportingCountry.Name}}</span>
          </div>
          <div style="display: flex; align-items: center; gap: 8px;">
            <div style="flex: 1;">
              <label class="ModernFormLabel">EN</label>
              <input type="text" class="ModernFormInput" placeholder="{{'EnterDescription' | translate}} (English)" [(ngModel)]="h.NewDescriptionEN" [disabled]="h.Saving">
            </div>
            <div style="flex: 1;">
              <label class="ModernFormLabel">RO</label>
              <input type="text" class="ModernFormInput" placeholder="{{'EnterDescription' | translate}} (Română)" [(ngModel)]="h.NewDescriptionRO" [disabled]="h.Saving">
            </div>
            <div style="padding-top: 16px;">
              <button class="ModernButton primary" [disabled]="h.Saving || (!h.NewDescriptionEN && !h.NewDescriptionRO)" (click)="SaveHSCodeDescriptions(h);">
                <span *ngIf="!h.Saving">{{'Save' | translate}}</span>
                <mat-spinner *ngIf="h.Saving" [diameter]="14"></mat-spinner>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="ModernPopupFooter" *ngIf="HSCodesPopupTab === 'hscodes'">
      <button class="ModernButton primary" (click)="this.InitializeNewHSCode(this.HSCodesFilter.Code);">
        <i class="material-icons">add</i> {{'AddNew' | translate}}
      </button>
      <button class="ModernButton outline" (click)="ShowHideHSCodesMenu();">
        <i class="material-icons">check</i> {{'OK' | translate}}
      </button>
    </div>
    <div class="ModernPopupFooter" *ngIf="HSCodesPopupTab === 'missing_descriptions'">
      <span style="font-size: 10px; color: #8e8e93; font-weight: 500;">
        {{ HSCodesWithoutDescriptions?.length || 0 }} {{'HSCodesMissingDescriptionsCount' | translate}}
      </span>
      <button class="ModernButton outline" [disabled]="HSCodesWithoutDescriptionsLoading" (click)="GetHSCodesWithoutDescriptions();">
        <i class="material-icons">refresh</i> {{'Refresh' | translate}}
      </button>
    </div>
  </div>
</div>

<!-- Add New HS Code Popup -->
<div class="ModernPopupOverlay" *ngIf="AddNewHSCode == true;" (click)="AddNewHSCode = false;" style="z-index: 10001;">
  <div class="ModernPopup small" (click)="$event.stopPropagation()">
    <div class="ModernPopupHeader">
      <div class="ModernPopupTitle">
        <i class="material-icons">add_circle_outline</i>
        <span>{{'AddNewHSCode' | translate}}</span>
      </div>
      <button class="ModernPopupClose" (click)="AddNewHSCode = false;">
        <i class="material-icons">close</i>
      </button>
    </div>
    <div class="ModernPopupBody">
      <div class="ModernFormGroup">
        <label class="ModernFormLabel">{{'Code' | translate}}</label>
        <input type="text" class="ModernFormInput" autocomplete="off" [(ngModel)]="this.NewHSCode.Code" placeholder="{{'Code' | translate}}"
               (blur)="ValidateAndSanitizeHSCode(this.NewHSCode)" [style.borderColor]="this.NewHSCode.HSCodeValid === false ? '#ff3b30' : ''">
        <div class="hscode-preview" *ngIf="getHSCodeParts(this.NewHSCode.Code).hasExcess">
          <span class="hscode-valid">{{getHSCodeParts(this.NewHSCode.Code).valid}}</span><span class="hscode-excess">{{getHSCodeParts(this.NewHSCode.Code).excess}}</span>
        </div>
      </div>
      <div class="ModernFormGroup">
        <label class="ModernFormLabel">{{'ImportTax' | translate}}</label>
        <input type="text" class="ModernFormInput" autocomplete="off" [(ngModel)]="this.NewHSCode.ImportTax" placeholder="{{'ImportTax' | translate}}">
      </div>
      <div class="ModernFormGroup">
        <label class="ModernFormLabel">{{'ExportTax' | translate}}</label>
        <input type="text" class="ModernFormInput" autocomplete="off" [(ngModel)]="this.NewHSCode.ExportTax" placeholder="{{'ExportTax' | translate}}">
      </div>
      <div class="ModernFormGroup" style="position: relative;">
        <label class="ModernFormLabel">{{'COO' | translate}}</label>
        <div style="position: relative; z-index: 202;">
          <input type="text" class="ModernFormInput" autocomplete="off" style="padding-right: 28px; position: relative; z-index: 203;"
                 placeholder="{{'COO' | translate}}"
                 [(ngModel)]="this.NewHSCode.COOSearchTerm"
                 (ngModelChange)="onCountrySearchChange($event)"
                 (click)="openCountryDropdown('newCOO', this.NewHSCode.COOSearchTerm)" (focus)="openCountryDropdown('newCOO', this.NewHSCode.COOSearchTerm)">
          <i class="material-icons" *ngIf="this.NewHSCode.COOSearchTerm?.length > 0"
             (click)="clearHSCountry(this.NewHSCode, 'COO')"
             style="position: absolute; right: 8px; top: 8px; font-size: 16px; color: #ff3b30; cursor: pointer; z-index: 203;">close</i>
          <i class="material-icons" *ngIf="!(this.NewHSCode.COOSearchTerm?.length > 0)"
             style="position: absolute; right: 8px; top: 8px; font-size: 16px; color: #8e8e93; pointer-events: none; z-index: 203;">search</i>
          <div *ngIf="activeCountryDropdown === 'newCOO'" (click)="closeCountryDropdown();" style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; z-index: 200; background: transparent;"></div>
          <div class="page-search-results" *ngIf="activeCountryDropdown === 'newCOO' && filteredCountries?.length > 0" style="top: 38px; z-index: 204;">
            <div class="page-search-result" *ngFor="let c of filteredCountries" (click)="selectHSCountry(this.NewHSCode, 'COO', c);">
              <span class="page-search-result-name">{{c.Name}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="ModernFormGroup" style="position: relative;">
        <label class="ModernFormLabel">{{'ImportingCountry' | translate}}</label>
        <div style="position: relative; z-index: 202;">
          <input type="text" class="ModernFormInput" autocomplete="off" style="padding-right: 28px; position: relative; z-index: 203;"
                 placeholder="{{'ImportingCountry' | translate}}"
                 [(ngModel)]="this.NewHSCode.ImportingCountrySearchTerm"
                 (ngModelChange)="onCountrySearchChange($event)"
                 (click)="openCountryDropdown('newImporting', this.NewHSCode.ImportingCountrySearchTerm)" (focus)="openCountryDropdown('newImporting', this.NewHSCode.ImportingCountrySearchTerm)">
          <i class="material-icons" *ngIf="this.NewHSCode.ImportingCountrySearchTerm?.length > 0"
             (click)="clearHSCountry(this.NewHSCode, 'ImportingCountry')"
             style="position: absolute; right: 8px; top: 8px; font-size: 16px; color: #ff3b30; cursor: pointer; z-index: 203;">close</i>
          <i class="material-icons" *ngIf="!(this.NewHSCode.ImportingCountrySearchTerm?.length > 0)"
             style="position: absolute; right: 8px; top: 8px; font-size: 16px; color: #8e8e93; pointer-events: none; z-index: 203;">search</i>
          <div *ngIf="activeCountryDropdown === 'newImporting'" (click)="closeCountryDropdown();" style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; z-index: 200; background: transparent;"></div>
          <div class="page-search-results" *ngIf="activeCountryDropdown === 'newImporting' && filteredCountries?.length > 0" style="top: 38px; z-index: 204;">
            <div class="page-search-result" *ngFor="let c of filteredCountries" (click)="selectHSCountry(this.NewHSCode, 'ImportingCountry', c);">
              <span class="page-search-result-name">{{c.Name}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="ModernPopupFooter">
      <button class="ModernButton primary" (click)="AddUpdateHSCode(this.NewHSCode);">
        <i class="material-icons">add</i> {{'AddNewHSCode' | translate}}
      </button>
    </div>
  </div>
</div>